import CircularProgress from "@mui/material/CircularProgress";
import { CardElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useState } from 'react';

const StripeCardBox = ({onSaveCard,loading, setLoading}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) return;
    setLoading(true);
    const { error, token } = await stripe.createToken(elements.getElement(CardElement))
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setError(null);
      onSaveCard(token?.id)
    }
  };
  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },

      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
  

  return (
    <form onSubmit={handleSubmit} className="stripe-add-card">
      <div className="stripe-add-card__container">
        <div className="stripe-add-card__box">
          
          <CardElement options={cardElementOptions} />
        </div>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <div className="stripe-add-card__action">
        <button type="submit" disabled={!stripe | loading} className="primary-button">
          {loading ? (
            <CircularProgress
            size={22}
            style={{
              color: "#ffffff",
            }}
          />
          ) : "Add Card"}
        </button>
      </div>
    </form>
  );
};

export default StripeCardBox;